// @ts-ignore
/* eslint-disable */
import request from '@/utils/request';

export interface LoginParams {
  email: string;
  password: string;
}

export interface RegisterParams {
  username: string;
  email: string;
  password: string;
}

/** User Login POST /api/auth/login */
export async function login(body: LoginParams, options?: { [key: string]: any }) {
  return request('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** User Registration POST /api/auth/register */
export async function register(body: RegisterParams, options?: { [key: string]: any }) {
  return request('/api/auth/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Get Current User Info GET /api/auth/me */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/auth/me', {
    method: 'GET',
    ...(options || {}),
  });
}
